import Modal from "@visiblethread/react-components/dist/components/Modal";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { useDispatch } from "react-redux";
import { resetDefaults } from "slices/settings/actions/thresholds";
import { DEFAULT_SETTINGS } from "constants/readabilityThresholds";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";

const ResetDefaultsModal = () => {
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.RESET_DEFAULTS_THRESHOLDS));
  };
  const handleSubmit = () => {
    dispatch(resetDefaults());
  };
  const settings = DEFAULT_SETTINGS;

  return (
    <Modal
      data-testid="resetDefaultThresholdsModal"
      className="thresholds_defaults_modal fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <b>Restore Thresholds</b>
      </Modal.Header>
      <Modal.Body>
        <p>
          We will revert all changes to thresholds to all users within the VT
          Docs workspace. The default threshold settings are:
        </p>
        <table
          className="table table-striped table-bordered"
          data-testid="resetDefaultsThresholdsModalTable"
        >
          <thead>
            <tr>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td>&nbsp;</td>
              <td>
                <strong>Bad</strong>
              </td>
              <td>
                <strong>Good</strong>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Long Sentences:</td>
              <td>{settings.thresholdLongSentenceUpper}%</td>
              <td>{settings.thresholdLongSentenceLower}%</td>
            </tr>
            <tr>
              <td>Passive Voice:</td>
              <td>{settings.thresholdPassiveVoiceUpper}%</td>
              <td>{settings.thresholdPassiveVoiceLower}%</td>
            </tr>
            <tr>
              <td>Average Sentence Length:</td>
              <td>{settings.thresholdAvgSentenceUpper} words</td>
              <td>{settings.thresholdAvgSentenceLower} words</td>
            </tr>
            <tr>
              <td>Readability (Flesch):</td>
              <td>{settings.thresholdReadabilityLower}</td>
              <td>{settings.thresholdReadabilityUpper}</td>
            </tr>
            <tr>
              <td>Readability (LIX):</td>
              <td>{settings.thresholdLixReadabilityUpper}</td>
              <td>{settings.thresholdLixReadabilityLower}</td>
            </tr>
            <tr>
              <td>Grade Level:</td>
              <td>{settings.thresholdGradeLevelUpper}</td>
              <td>{settings.thresholdGradeLevelLower}</td>
            </tr>
            <tr>
              <td>Long Sentence Cutoff:</td>
              <td colSpan="2">25 words</td>
            </tr>
            <tr>
              <td>Very Long Sentence Cutoff:</td>
              <td colSpan="2">30 words</td>
            </tr>
            <tr>
              <td>Lix score for all folders:</td>
              <td colSpan="2">disabled</td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleSubmit}
          variant={buttonVariants.primary}
          content="Confirm"
        />
        <Button
          onClick={handleCancel}
          variant={buttonVariants.secondary}
          content="Close"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ResetDefaultsModal;
